import { Dropdown, DropdownItem } from '@acies/ui';

export default class ModelTypeDropdown extends Dropdown {
	/** The types on offer, built once: a reset changes what is picked, not what there is. */
	#items: DropdownItem[];
	public constructor() {
		super();
		this.width = 72;
		this.minWidth = 72;
		// a position is a model unless the user says otherwise, so the row starts on one
		this.autoSelectFirstItem = true;
		this.#items = [
			new DropdownItem({ icon: 'layout-grid-01', value: 'model' }),
			new DropdownItem({ icon: 'package', value: 'stock' }),
			// out of reach until the row has somewhere to type the text it shows, rather than gone: a
			// text position is a real kind, and everything downstream still knows how to build one
			// new DropdownItem({ icon: 'type-02', value: 'text' }),
		];
		this.reset();
	}

	/**
	 * Offers the types again with none of them picked.
	 *
	 * Handing the list new data is what takes the selection back: the list drops its selection whenever its data is replaced. Cleared to null first, since the list ignores data it is already holding — and the same items go back, so nothing is rebuilt for a reset.
	 */
	public reset(): void {
		this.data = null;
		this.data = this.#items;
	}
}
customElements.define('cf-model-type-dropdown', ModelTypeDropdown);
